// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__228wl","header":"Messages_header__3um2m"};